// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"b8-z","refreshPageWarning":"c8-z","redirectMessageText":"d8-z"};